export const myClassLog = {
  view_06_09_01_01: 'view_06_09_01_01', // 我的班级页面展示
  show_06_09_02_01: 'show_06_09_02_01', // 批量工具展示-面积展示大于60%、在页面停留时长大于500ms上报，在页面内由于轮播、滑动等重复展示重复上报
  click_06_09_02_02: 'click_06_09_02_02', // 点击群发群消息工具
  click_06_09_02_03: 'click_06_09_02_03', // 点击群发企微消息工具
  show_06_09_03_01: 'show_06_09_03_01', // 群发企微消息类型选择弹窗展示-面积展示大于60%、在页面停留时长大于500ms上报，在页面内由于轮播、滑动等重复展示重复上报
  click_06_09_03_02: 'click_06_09_03_02', // 点击选择无限群发按钮
  click_06_09_03_03: 'click_06_09_03_03', // 点击选择极速群发按钮
  show_06_09_04_01: 'show_06_09_04_01', // 无限群发前置筛选侧边栏展示
  click_06_09_04_02: 'click_06_09_04_02', // 点击无限群发前置筛选侧边栏下一步按钮
  click_06_09_04_03: 'click_06_09_04_03', // 点击无限群发前置筛选侧边栏取消按钮
  click_06_09_04_04: 'click_06_09_04_04', // 点击无限群发前置筛选侧边栏返回上一步按钮
  show_06_09_05_01: 'show_06_09_05_01', // 无限群发内容编辑侧边栏展示
  click_06_09_05_02: 'click_06_09_05_02', // 点击无限群发内容编辑侧边栏取消按钮
  click_06_09_05_03: 'click_06_09_05_03', // 点击无限群发内容编辑侧边栏定时群发按钮
  click_06_09_05_04: 'click_06_09_05_04', // 点击无限群发内容编辑侧边栏立即发送按钮
  click_06_09_05_05: 'click_06_09_05_05', // 点击无限群发内容编辑侧边栏返回上一步按钮
  show_06_09_06_01: 'show_06_09_06_01', // 极速群发前置筛选侧边栏展示
  click_06_09_06_02: 'click_06_09_06_02', // 点击极速群发前置筛选侧边栏返回上一步按钮
  click_06_09_06_03: 'click_06_09_06_03', // 点击极速群发前置筛选侧边栏取消按钮
  click_06_09_06_04: 'click_06_09_06_04', // 点击极速群发前置筛选侧边栏下一步按钮
  show_06_09_07_01: 'show_06_09_07_01', // 极速群发内容编辑侧边栏展示
  click_06_09_07_02: 'click_06_09_07_02', // 点击极速群发内容编辑侧边栏返回上一步按钮
  click_06_09_07_03: 'click_06_09_07_03', // 点击极速群发内容编辑侧边栏取消按钮
  click_06_09_07_04: 'click_06_09_07_04', // 点击极速群发内容编辑侧边栏定时发送按钮
  click_06_09_07_05: 'click_06_09_07_05', // 点击极速群发内容编辑侧边栏立即发送按钮
  show_06_09_08_01: 'show_06_09_08_01', // 群发群消息类型选择弹窗展示
  click_06_09_08_02: 'click_06_09_08_02', // 点击选择无限群发群消息按钮
  click_06_09_08_03: 'click_06_09_08_03', // 点击选择极速群发群消息按钮
  show_06_09_09_01: 'show_06_09_09_01', // 无限群发群消息内容编辑侧边栏展示
  click_06_09_09_02: 'click_06_09_09_02', // 点击无限群发群消息内容编辑侧边栏回上一步按钮
  click_06_09_09_03: 'click_06_09_09_03', // 点击无限群发群消息内容编辑侧边栏取消按钮
  click_06_09_09_04: 'click_06_09_09_04', // 点击无限群发群消息内容编辑侧边栏定时发送按钮
  click_06_09_09_05: 'click_06_09_09_05', // 点击无限群发群消息内容编辑侧边栏立即发送按钮
  show_06_09_10_01: 'show_06_09_10_01', // 极速群发群消息内容编辑侧边栏展示
  click_06_09_10_02: 'click_06_09_10_02', // 点击极速群发群消息内容编辑侧边栏回上一步按钮
  click_06_09_10_03: 'click_06_09_10_03', // 点击极速群发群消息内容编辑侧边栏定时发送按钮
  click_06_09_10_04: 'click_06_09_10_04', // 点击极速群发群消息内容编辑侧边栏立即发送按钮
  click_60_01_08_01: 'click_60_01_08_01', //	我的班级
  click_60_01_08_02: 'click_60_01_08_02', //	班级类型筛选
  click_60_01_08_03: 'click_60_01_08_03', //	服务状态筛选
  click_60_01_08_04: 'click_60_01_08_04', //	班级卡片
  click_60_01_08_05: 'click_60_01_08_05', //	班级卡片-左滑动
  click_60_01_08_06: 'click_60_01_08_06', //	班级卡片右滑动
  click_60_01_08_07: 'click_60_01_08_07', //	收起/展开卡片
  click_60_01_08_08: 'click_60_01_08_08', //	全部班级
  click_60_01_08_09: 'click_60_01_08_09', //	全部班级-关闭
  click_60_01_08_10: 'click_60_01_08_10', //	卡片内-复制
  click_60_01_08_11: 'click_60_01_08_11', //	卡片内-星标
  click_60_01_08_12: 'click_60_01_08_12', //	卡片内-点击讲次
  click_60_01_08_13: 'click_60_01_08_13', //	右上角搜索
  click_60_01_08_14: 'click_60_01_08_14', //	右上角搜索-点击搜索结果
  click_60_01_08_15: 'click_60_01_08_15', //	点击班级
  click_60_01_08_16: 'click_60_01_08_16', //	我的班级-点击讲次
  click_60_01_08_17: 'click_60_01_08_17' //	点击模块
};
export const logPageType = {
  newMyClass: '1', // 新体验模式
  myClass: '2', // 我的班级
  myPrivateSea: '3', // 我的私海
  highPrivateSea: '4' // 我的私海（高）
};
export const logModuleType = {
  // 班级学员
  student: '1',
  // 新体验模式下的班级学员
  newStudent: '1',
  // 讲次表现
  lesson: '2',
  // 全讲次表现
  allLesson: '3',
  // 新体验模式下的讲次表现
  newLesson: '2',
  // 全讲次表现
  allClassPerformance: '3',
  // 新体验模式下的全讲次表现
  newAllLesson: '3'
};
